import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountSelectionService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { ActivateAdsAutomationCtaComponent } from "@m19-board/shared/activate-ads-automation-cta/activate-ads-automation-cta.component";
import { FeaturePitchOverlayComponent } from "@m19-board/overlay/feature-pitch-overlay/feature-pitch-overlay.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-sd-bidder-off-overlay",
  imports: [TranslocoDirective, FeaturePitchOverlayComponent, ActivateAdsAutomationCtaComponent],
  template: `
    <app-feature-pitch-overlay *transloco="let t" feature="sd" [title]="t('overlays.bidder_off_title')">
      <app-activate-ads-automation-cta [accountMarketplace]="accountMarketplace()" />
    </app-feature-pitch-overlay>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdBidderOffOverlayComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);

  static readonly rule = OverlayRule.BIDDER_OFF;

  protected readonly accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });
}
